import { DictionaryEntry } from '@sdbn/common';
import { MasterDetailListEntry } from '@sdbn/common';
import { Description } from '../erp-common/erp-common.model';


export enum ArticleTypeCalculationPrecission {
    NUMBER = 'NUMBER',
    DECIMAL = 'DECIMAL',
    ATTRIBUTE = 'ATTRIBUT'
}

export enum ArticleTypeCalculationMethod {
    ADD = 'ADD',
    SUBTRACT = 'SUBTRACT'
}

export enum ArticleTypeAttributeType {
    NUMBER = 'NUMBER',
    DECIMAL = 'DECIMAL',
    STRING = 'STRING',
    DATE = 'DATE',
    TEXT = 'TEXT',
    BOOLEAN = 'BOOLEAN',
    LOOKUP = 'LOOKUP'
}

export enum AttributeGroupUsage {
  ARTICLE = 'ARTICLE',
  POSITION = 'POSITION',
  COSTSPRICE = 'COSTSPRICE'
}

export class ArticleType implements MasterDetailListEntry {

    id: number;

    archived = false;

    name = new DictionaryEntry();

    title = '';

    identifierPattern = '';

    attributeGroups = new Array<ArticleTypeAttributeGroup>();

    calculationRules = new Array<ArticleTypeCalculationRuleAttribute>();

    basicArticleDefinition = new BasicArticleDefinition({});

    parentArticleTypeId: number;

    completeArticleType: ArticleType;

    constructor(type: any) {
        this.id = type.id;
        this.identifierPattern = type.identifierPattern;

        if (type.archived != null) {
          this.archived = type.archived;
        }
        if (type.name != null) {
            this.name = new DictionaryEntry(type.name);
        }
        if (type.basicArticleDefinition != null) {
            this.basicArticleDefinition = new BasicArticleDefinition(type.basicArticleDefinition);
        }
        if (type.calculationRules != null) {
            for (const rule of type.calculationRules) {
                this.calculationRules.push(new ArticleTypeCalculationRuleAttribute(rule));
            }
        }
        if (type.attributeGroups != null) {
            for (const group of type.attributeGroups) {
                this.attributeGroups.push(new ArticleTypeAttributeGroup(group));
            }
        }

        // sort groups
        this.attributeGroups.sort( (a, b) => {
          if (a.sortValue == null && b.sortValue == null) {
            return 0;
          }
          if (a.sortValue == null || b.sortValue == null) {
            return -1;
          }
          return a.sortValue.localeCompare(b.sortValue);
        });

        this.parentArticleTypeId = type.parentArticleTypeId;

        if (type.completeArticleType != null) {
            this.completeArticleType = new ArticleType(type.completeArticleType);
        }
    }

    public get childs(): MasterDetailListEntry[] {
      return null;
    }

    public get groupIdentifier(): string {
      return null;
    }

    public get listTitle(): string {
        return this.title;
    }

    public get listTitleDictionaryKey(): string {
        return null;
    }

    public get listSubTitle(): string {
        return null;
    }

    public calculateTitle(language: string) {
      const nameValue = this.name.getValue(language);
      this.title = nameValue != null ? nameValue.value : null;
    }

    public linkDetails(): ArticleType {

        if (this.basicArticleDefinition != null && this.basicArticleDefinition.attributes != null) {
            for (let attribute of this.basicArticleDefinition.attributes) {
                attribute.articleTypeAttribute = this.findArticleTypeAttributeById(attribute.attributeId);
            }
        }

        if (this.completeArticleType != null) {
            this.completeArticleType.linkDetails();
        }
        
        return this;
    }

    public findArticleTypeAttributeById(id: number): ArticleTypeAttribute {
        for (let group of this.attributeGroups) {
            for (let attribute of group.attributes) {
                if (attribute.id === id) {
                    return attribute;
                }
            }
        }
        return null;
    }

}

export class ArticleTypeAttributeGroup {

    id: number;
    name = new DictionaryEntry();
    descriptions = new Array<Description>();
    attributes = new Array<ArticleTypeAttribute>();
    deleted = false;
    sortValue: string;
    groupKey: string;
    usage: AttributeGroupUsage;

    constructor(group: any) {
        this.id = group.id;
        this.sortValue = group.sortValue;
        this.groupKey = group.groupKey;
        this.usage = group.usage;
        this.deleted = group.deleted === true;
        if (group.name != null) {
            this.name = new DictionaryEntry(group.name);
        }
        // TODO this.descriptions = group.descriptions
        if (group.attributes != null) {
            for (const attribute of group.attributes) {
                this.attributes.push(new ArticleTypeAttribute(attribute));
            }
        }

        this.attributes.sort( (a, b) => {
          if (a.sortValue == null && b.sortValue == null) {
            return 0;
          }
          if (a.sortValue == null || b.sortValue == null) {
            return -1;
          }
          return a.sortValue.localeCompare(b.sortValue);
        });
    }

}

export class ArticleTypeAttribute {

    id: number;
    type: ArticleTypeAttributeType;
    name = new DictionaryEntry();
    mandatory: boolean;
    defaultValue: string;
    deleted = false;
    sortValue: string;

    values = new Array<ArticleTypeAttributeValue>();
    defaultValueId: number;

    constructor(attribute: any) {
        this.id = attribute.id;
        this.type = attribute.type;
        this.sortValue = attribute.sortValue;
        if (attribute.name != null) {
            this.name = new DictionaryEntry(attribute.name);
        }
        this.mandatory = attribute.mandatory;
        this.defaultValue = attribute.defaultValue;
        this.defaultValueId = attribute.defaultValueId;

        this.deleted = attribute.deleted === true;

        if (attribute.values != null) {
            for (const value of attribute.values) {
                this.values.push(new ArticleTypeAttributeValue(value));
            }
            this.values.sort((a, b) => {
              if (a.sortValue == null && b.sortValue == null) {
                return 0;
              }
              if (a == null || a.sortValue == null) {
                return -1;
              }
              if (b == null || b.sortValue == null) {
                return 1;
              }
              return a.sortValue.localeCompare(b.sortValue);
            });
        }
    }

}

export class ArticleTypeCalculationRuleAttribute {

    id: number;
    name: DictionaryEntry;
    precission: ArticleTypeCalculationPrecission;
    attributeId: number;
    method: ArticleTypeCalculationMethod;
    calculationIndex: number = 0;
    deleted = false;
    sortValue: string;

    constructor(rule: any) {
        this.id = rule.id;
        this.copyValues(rule);
        this.deleted = rule.deleted === true;
        this.sortValue = rule.sortValue;
    }

    copyValues(rule: any) {
        this.name = new DictionaryEntry(rule.name);
        this.precission = rule.precission;
        this.method = rule.method;
        this.calculationIndex = rule.calculationIndex != null ? rule.calculationIndex : 0;
        this.attributeId = rule.attributeId;
        this.sortValue = rule.sortValue;
    }

}

export class ArticleTypeAttributeValue {

    id: number;
    value: string;
    sortValue: string;
    deleted = false;

    // article type attribute

    constructor(value: any) {
        this.id = value.id;
        this.value = value.value;
        this.sortValue = value.sortValue;
        this.deleted = value.deleted != null && value.deleted === true;
    }

}

export class BasicArticleDefinition {

    id: number;
    attributes = new Array<BasicArticleDefinitionAttribute>();

    constructor(definition: any) {
        this.id = definition.id;
        if (definition.attributes != null) {
            for (const attribute of definition.attributes) {
                this.attributes.push(new BasicArticleDefinitionAttribute(attribute));
            }
        }
    }

}

export class BasicArticleDefinitionAttribute {

    id: number;
    attributeId: number;
    articleTypeAttribute: ArticleTypeAttribute;

    constructor(attribute: any) {
        this.id = attribute.id;
        this.attributeId = attribute.attributeId;
    }

}
